import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/home";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        solid
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 md:h-[72px] flex items-center justify-between">
        <a
          href="#top"
          className="flex items-center gap-2.5 cursor-pointer group"
          aria-label="茶杯狐影视 首页"
        >
          <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 dark:text-foreground-950">
            <i className="ri-film-line text-xl"></i>
          </span>
          <span
            className={`font-heading text-lg md:text-xl font-bold tracking-tight transition-colors ${
              solid ? "text-foreground-950" : "text-background-50"
            }`}
          >
            茶杯狐影视
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              className={`px-3 py-2 text-sm rounded-md whitespace-nowrap transition-colors cursor-pointer ${
                solid
                  ? "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                  : "text-background-100/90 hover:text-background-50 hover:bg-background-50/10"
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#catalog"
            className="hidden sm:inline-flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors bg-primary-500 text-background-50 dark:text-foreground-950 hover:bg-primary-600"
          >
            <i className="ri-play-fill"></i>
            开始观看
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="切换导航菜单"
            aria-expanded={open}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer transition-colors ${
              solid ? "text-foreground-900" : "text-background-50"
            }`}
          >
            <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-background-50 border-t border-background-200">
          <nav className="w-full px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={() => setOpen(false)}
                className="px-3 py-3 text-sm text-foreground-800 rounded-md hover:bg-background-100 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#catalog"
              onClick={() => setOpen(false)}
              className="mt-1 px-3 py-3 text-sm font-medium text-center rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 cursor-pointer"
            >
              开始观看
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}